import React, { useState, useEffect, useContext, useRef } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	Dialog
} from '@mui/material';
import { isEmpty } from 'lodash';

import { useParams } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';

import { getToken, getUser } from '../../../api/Account';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import NoData from '../../../components/NoData';
import { getBosqueMoraAsync, getSaldoCarteraByGestorAsync } from '../../../api/Report';
import { PrintReport } from '../../../components/PrintReport';
import moment from 'moment';
import { getGestoresAsync } from '../../../api/Users';
import { simpleMessage } from '../../../helpers/Helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx/xlsx.mjs';

const BosqueMora = () => {
	const [data, setData] = useState([]);

	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const compRef = useRef();
	const { selectedGestor } = useParams();
	const [gestorName, setGestorName] = useState('');
	const [gestorList, setGestorList] = useState([]);

	const token = getToken();
	const user = getUser();

	useEffect(() => {
		(async () => {
			let gestores = await getGestores();

			if (selectedGestor === 't') {
				setGestorName('Todos');
			} else {
				let name = gestores.filter((item) => item.id.toString() === selectedGestor);

				setGestorName(name[0].fullName);
			}

			let gestorId = selectedGestor === 't' ? 0 : selectedGestor;

			setIsLoading(true);
			const result = await getBosqueMoraAsync(token, gestorId);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setData(result.data.result);
			setIsLoading(false);
		})();
	}, []);

	const pageStyle = `
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }
    @media all {
      .pagebreak {
        display: none;
      }
    }
    @media print {
      .pagebreak {
        page-break-before: always;
      }
    }  
    @page { size: landscape;  margin: 3mm; }
  `;

	let totalTemprana = 0;
	let totalAvanzada = 0;
	let totalRiesgo = 0;
	let totalRiesgoPerdido = 0;
	let totalVencido = 0;

	const exportExcel = () => {
		let exp = [];
		data.map((item) => {
			const { avanzada, gestor, riesgo, riesgoPerdido, temprana, vencido } = item;

			let obj = {
				gestor,
				temprana,
				avanzada,
				riesgo,
				riesgoPerdido,
				vencido
			};
			exp.push(obj);
		});

		var bk = XLSX.utils.book_new(),
			bs = XLSX.utils.json_to_sheet(exp);

		XLSX.utils.book_append_sheet(bk, bs, 'bosqueMora');
		XLSX.writeFile(bk, 'BosqueMora.xlsx');
	};

	const getGestores = async () => {
		setIsLoading(true);
		const result = await getGestoresAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);

		setGestorList(
			selectedGestor === 't'
				? result.data.result
				: result.data.result.filter((g) => g.id.toString() === selectedGestor)
		);

		return result.data.result;
	};

	return (
		<div>
			<Dialog fullScreen open={true}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
						<Typography
							sx={{ ml: 2, flex: 1, textAlign: 'center' }}
							variant="h5"
							component="div"
						>
							{`${title} `}
						</Typography>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
					</Toolbar>
				</AppBar>

				<Stack display="flex" justifyContent="center">
					<Stack
						direction={'row'}
						justifyContent="space-between"
						paddingLeft={5}
						paddingRight={5}
						marginTop={1}
						marginBottom={1}
					>
						<IconButton variant="outlined" onClick={() => exportExcel()}>
							<FontAwesomeIcon
								icon={faCloudArrowDown}
								style={{ fontSize: 40, color: '#00a152', width: 40 }}
							/>
						</IconButton>

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
								variant="h6"
								component="div"
							>
								Reporte de Bosque de Mora
							</Typography>
						</Stack>

						<ReactToPrint
							trigger={() => {
								return (
									<IconButton
										variant="outlined"
										// style={{ position: "fixed", right: 20, top: 75 }}
									>
										<PrintRoundedIcon
											style={{ fontSize: 40, color: '#2979ff', width: 40 }}
										/>
									</IconButton>
								);
							}}
							content={() => compRef.current}
							pageStyle={pageStyle}
						/>
					</Stack>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="space-between">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Parametros:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Gestor Seleccionado: ${
										selectedGestor === 't' ? 'Todos' : gestorName
									}`}
								</Typography>
							</Stack>
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						{isEmpty(data) ? (
							<NoData />
						) : (
							<>
								<TableContainer>
									<Table aria-label="simple table" size="small">
										<TableHead>
											<TableRow>
												<TableCell
													align="left"
													className="text-primary fw-bold"
												>
													Gestor
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Temprana
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Avanzada
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Riesgo
												</TableCell>
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Riesgo Perdido
												</TableCell>
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Vencido
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{data.map((row) => {
												const {
													avanzada,
													gestor,
													riesgo,
													riesgoPerdido,
													temprana,
													vencido
												} = row;

												totalTemprana += temprana;
												totalAvanzada += avanzada;
												totalRiesgo += riesgo;
												totalRiesgoPerdido += totalRiesgoPerdido;
												totalVencido += vencido;

												return (
													<TableRow key={gestor}>
														<TableCell
															align="left"
															component="th"
															scope="row"
															style={{ fontSize: 11 }}
														>
															{gestor}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
														>
															{temprana}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
														>
															{avanzada}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
														>
															{riesgo}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
														>
															{riesgoPerdido}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
														>
															{vencido}
														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>

								{gestorList.length === 1 ? (
									<></>
								) : (
									<Stack>
										<Typography
											sx={{
												color: '#2196f3',
												textAlign: 'center'
											}}
										>
											Consolidado
										</Typography>

										<hr />

										<Stack
											direction="row"
											flex="row"
											justifyContent="space-around"
										>
											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Temprana
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalTemprana}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Avanzada
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalAvanzada}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Riesgo
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalRiesgo}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Riesgo Perdido
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalRiesgoPerdido}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Vencido
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalVencido}
												</Typography>
											</Stack>
										</Stack>
										<hr />
									</Stack>
								)}
							</>
						)}
					</Container>
				</Stack>
			</Dialog>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport
					ref={compRef}
					titulo={'Reporte de Bosque de Mora'}
					fecha={`Fecha: ${moment().format('L')}`}
				>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="space-between">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Parametros:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Gestor Seleccionado: ${
										selectedGestor === 't' ? 'Todos' : gestorName
									}`}
								</Typography>
							</Stack>
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						{isEmpty(data) ? (
							<NoData />
						) : (
							<>
								<TableContainer>
									<Table aria-label="simple table" size="small">
										<TableHead>
											<TableRow>
												<TableCell
													align="left"
													className="text-primary fw-bold"
												>
													Gestor
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Temprana
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Avanzada
												</TableCell>

												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Riesgo
												</TableCell>
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Riesgo Perdido
												</TableCell>
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Vencido
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{data.map((row) => {
												const {
													avanzada,
													gestor,
													riesgo,
													riesgoPerdido,
													temprana,
													vencido
												} = row;

												return (
													<TableRow key={gestor}>
														<TableCell
															align="left"
															component="th"
															scope="row"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{gestor}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{temprana}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{avanzada}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{riesgo}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{riesgoPerdido}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontSize: 11 }}
															className="text-dark"
														>
															{vencido}
														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>

								{gestorList.length === 1 ? (
									<></>
								) : (
									<Stack>
										<Typography
											sx={{
												color: '#2196f3',
												textAlign: 'center'
											}}
										>
											Consolidado
										</Typography>

										<hr />

										<Stack
											direction="row"
											flex="row"
											justifyContent="space-around"
										>
											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Temprana
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalTemprana}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Avanzada
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalAvanzada}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Riesgo
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalRiesgo}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Riesgo Perdido
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalRiesgoPerdido}
												</Typography>
											</Stack>

											<Stack textAlign="center">
												<Typography
													style={{
														fontWeight: 'bold',
														color: '#03a9f4',
														fontSize: 11
													}}
												>
													Total Vencido
												</Typography>
												<Typography style={{ fontSize: 11 }}>
													{totalVencido}
												</Typography>
											</Stack>
										</Stack>
										<hr />
									</Stack>
								)}
							</>
						)}
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default BosqueMora;
